import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import { Form } from "react-bootstrap";
import { packagesServices } from "../../APIServices/Editor/packagesServices";

const CodeCompareModal = ({
  show,
  title,
  bounds,
  setShow,
  onStart,
  disabled,
  onMouseOut,
  draggleRef,
  onMouseOver,
  fileId,
  codeVersionHistory
}) => {
  const [versionLeftCode, setVersionLeftCode] = useState("");
  const [versionRightCode, setVersionRightCode] = useState("");
  const [totalVersion, setTotalVersion] = useState([]);
  const getPackageCodeByVersionLeft = async (version) => {
    let data = await packagesServices.getPackageCodeByVersion(fileId, version)
    setVersionLeftCode(data?.code)
  }

  const getPackageCodeByVersionRight = async (version) => {
    let data = await packagesServices.getPackageCodeByVersion(fileId, version)
    setVersionRightCode(data?.code)
  }

  useEffect(() => {
    let totalVersionData = Array.from({ length: codeVersionHistory?.length }, (_, i) => i + 1)
    setTotalVersion(totalVersionData || []);
  }, [fileId, codeVersionHistory]);

  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={1100}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css">
          <div className="hstack justify-content-between border-bottom pb-3">
            <div className="hstack gap-2 text-nowrap">
              <Form.Label>Select Version</Form.Label>
              <Form.Select
                onChange={(e) => getPackageCodeByVersionLeft(e.target.value)}
              >
                <option selected>Select Version</option>
                {totalVersion?.map((item, index) => (
                  <option key={index} value={item}>v{item}.0.0</option>
                ))}
              </Form.Select>
            </div>
            <div className="hstack gap-2 text-nowrap">
              <Form.Label>Select Version</Form.Label>
              <Form.Select
                onChange={(e) => getPackageCodeByVersionRight(e.target.value)}
              >
                <option selected>Select Version</option>
                {totalVersion?.map((item, index) => (
                  <option key={index} value={item}>v{item}.0.0</option>
                ))}
              </Form.Select>
            </div>
          </div>
          <div className="diffTabHeight">
          <ReactDiffViewer
            newValue={versionRightCode}
            oldValue={versionLeftCode}
            compareMethod={DiffMethod.WORDS}
            splitView={true}
          />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default CodeCompareModal;
